export default __webpack_public_path__ + "static/media/icons-menu-map-active.229b92ec.svg";